function h(e, u) {
  for (var l = -1, n = e == null ? 0 : e.length, t = Array(n); ++l < n; )
    t[l] = u(e[l], l, e);
  return t;
}
export {
  h as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_arrayMap.js
// module id = 861
// module chunks = 41